import "./css/FullScreenLoaderAnimation.css"
import React from 'react'

export default function FullScreenLoaderAnimation(props) {
        const [keepAnimating, setKeepAnimating] = React.useState(true)
        if (props.with_time){
                setTimeout(() => {
                        setKeepAnimating(false)
                }, props.with_time)
        }
        if (!props.with_time && !props.animation_condition) {
                setTimeout(() => {
                        setKeepAnimating(false)
                }, 5000)
        }
        function loader_component(){
                return (
                        <div style={{ height: props.height || "100%", width: props.width || "100%", position: "absolute" }} >
                                <div id="main-loader">
                                        <div id="holder" align="center">
                                                <div id="graph-container">
                                                        <div id="animation-div" className="container p-0 w-100">
                                                                <div className="bars-cont p-0">
                                                                        <span className="bar bar-1"></span>
                                                                        <span className="bar bar-2"></span>
                                                                        <span className="bar bar-3"></span>
                                                                        <span className="bar bar-4"></span>
                                                                        <span className="bar bar-5"></span>
                                                                </div>
                                                        </div>
                                                </div>
                                                <p className="mt-4 font-weight-bold" style={{ fontSize: "25px" }}>
                                                        loading . . .
                                                </p>
                                        </div>
                                </div>
                        </div>
                )
        }


        return (
                <React.Fragment>
                        {props.with_time?
                                <React.Fragment>
                                        {keepAnimating?
                                                loader_component()
                                                :
                                                null
                                        }
                                </React.Fragment>
                                :
                                <React.Fragment>
                                {
                                        props.animation_condition ?
                                                loader_component()
                                                :
                                                null
                                }
                                </React.Fragment>
                        }
                </React.Fragment>
        )
}
